import { withNamespaces } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Spinner,
    UncontrolledDropdown,
} from 'reactstrap';

import {
    getAvailableMailboxIntents,
    getMailboxCaseDetailLocation,
    getMailboxIntentItem,
    getMailboxLinkedCaseId,
} from '../../../helpers';

const MessageRowIntents = ({
    t,
    messageId,
    message,
    intents = [],
    cases = [],
    applying = null,
    isActing = false,
    onApplyIntent,
}) => {
    const location = useLocation();
    const availableIntents = getAvailableMailboxIntents(intents, message, cases);
    const isBusy = applying?.messageId === messageId;
    const disabled = isActing || Boolean(applying);

    return (
        <>
            {cases.length > 1 ? (
                <UncontrolledDropdown className="me-1">
                    <DropdownToggle
                        tag="button"
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        disabled={disabled}
                    >
                        {t('{{count}} Linked Items', { count: cases.length })}
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                        {cases.map((linkedCase) => {
                            const intentItem = getMailboxIntentItem(linkedCase.intent);
                            const path = getMailboxCaseDetailLocation(linkedCase, location);
                            const caseId = getMailboxLinkedCaseId(linkedCase);

                            if (!path) {
                                return (
                                    <DropdownItem
                                        key={`${linkedCase.intent}-${caseId}`}
                                        disabled
                                    >
                                        {t(intentItem?.titleKey || 'Case ID')}
                                    </DropdownItem>
                                );
                            }

                            return (
                                <DropdownItem
                                    key={`${linkedCase.intent}-${caseId}`}
                                    tag={Link}
                                    to={path}
                                >
                                    {t(intentItem?.titleKey || 'Case ID')}
                                    <i className="mdi mdi-open-in-new ms-1" />
                                </DropdownItem>
                            );
                        })}
                    </DropdownMenu>
                </UncontrolledDropdown>
            ) : null}

            {cases.length === 1 ? (
                (() => {
                    const linkedCase = cases[0];
                    const intentItem = getMailboxIntentItem(linkedCase.intent);
                    const path = getMailboxCaseDetailLocation(linkedCase, location);

                    if (!path) {
                        return null;
                    }

                    return (
                        <Link
                            to={path}
                            className="btn btn-sm btn-outline-primary me-1"
                            title={t(intentItem?.titleKey || 'Open case')}
                        >
                            {t(intentItem?.buttonKey || 'Open case')}
                            <i className="mdi mdi-open-in-new ms-1" />
                        </Link>
                    );
                })()
            ) : null}

            {availableIntents.length ? (
                <UncontrolledDropdown className="me-1">
                    <DropdownToggle
                        tag="button"
                        type="button"
                        className="btn btn-primary mailbox-message-row__add"
                        disabled={disabled}
                        title={t('Add to Incident or Request')}
                    >
                        {isBusy ? (
                            <Spinner size="sm" />
                        ) : (
                            <i className="mdi mdi-plus" />
                        )}
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                        {availableIntents.map((item) => (
                            <DropdownItem
                                key={item.code}
                                disabled={disabled}
                                onClick={() => onApplyIntent(messageId, item.code)}
                            >
                                <i className="mdi mdi-plus me-1" />
                                {t(item.addKey)}
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </UncontrolledDropdown>
            ) : null}
        </>
    );
};

export default withNamespaces()(MessageRowIntents);
